/** Only customer-adjusted heights inform prescriptions; demographic defaults are examples. */
export function tallestStatedSleeper(capacity: {
  occupants?: string[]
  heightInches?: Record<string, number | undefined>
}): number | null {
  const values = (capacity.occupants ?? [])
    .map(id => capacity.heightInches?.[id])
    .filter(
      (height): height is number =>
        typeof height === 'number' && Number.isFinite(height) && height >= 30 && height <= 84
    )
  return values.length ? Math.max(...values) : null
}
